export class Track {
  id: number;
  name: string;
  type: 'technical' | 'fast'
}

export const TRACK_LIST: Track[] = [
  { id: 1, name: '24 Heures du Mans Racing Circuit', type: 'fast' },
  { id: 2, name: '24 Heures du Mans Racing Circuit No Chicane', type: 'fast' },
  { id: 3, name: 'Autodromo Nazionale Monza', type: 'fast' },
  { id: 4, name: 'Autodromo Nazionale Monza No Chicane', type: 'fast' },
  { id: 5, name: 'Blue Moon Bay Speedway', type: 'fast' },
  { id: 6, name: 'Blue Moon Bay Speedway Reverse', type: 'fast' },
  { id: 7, name: 'High Speed Ring', type: 'fast' },
  { id: 8, name: 'High Speed Ring Reverse', type: 'fast' },
  { id: 9, name: 'Special Stage Route X', type: 'fast' },
  { id: 10, name: 'Daytona Tri-Oval', type: 'fast' },
  { id: 11, name: 'Northern Isle Speedway', type: 'fast' },
  { id: 12, name: 'Circuit de Sainte-Croix – A', type: 'fast' },
  { id: 13, name: 'Circuit de Sainte-Croix – A Reverse', type: 'fast' },
  { id: 14, name: 'Circuit de Sainte-Croix – B', type: 'fast' },
  { id: 15, name: 'Circuit de Sainte-Croix – B Reverse', type: 'fast' },
  { id: 16, name: 'Circuit de Sainte-Croix – C', type: 'fast' },
  { id: 17, name: 'Circuit de Sainte-Croix – C Reverse', type: 'fast' },
  { id: 18, name: 'Sardegna – Road Track – A', type: 'fast' },
  { id: 19, name: 'Spa 24h Layout', type: 'fast' },
  { id: 20, name: 'Red Bull Ring', type: 'fast' },
  { id: 21, name: 'Red Bull Ring Short Track', type: 'fast' },
  { id: 22, name: 'Grand Valley – Highway 1', type: 'fast' },
  { id: 23, name: 'Grand Valley – Highway 1 Reverse', type: 'fast' },
  { id: 24, name: 'Nurburgring Endurance', type: 'fast' },
  { id: 25, name: 'Fuji International Speedway', type: 'fast' },
  { id: 26, name: 'Fuji International Speedway (Short)', type: 'fast' },
  { id: 27, name: 'Watkins Glen Long Course', type: 'fast' },
  { id: 28, name: 'Watkins Glen Short Course', type: 'fast' },
  { id: 29, name: 'WeatherTech Raceway Laguna Seca', type: 'fast' },

  { id: 30, name: 'Alsace – Test Course', type: 'technical' },
  { id: 31, name: 'Alsace – Test Course Reverse', type: 'technical' },
  { id: 32, name: 'Alsace – Village', type: 'technical' },
  { id: 33, name: 'Alsace – Village Reverse', type: 'technical' },
  { id: 34, name: 'Autodrome Lago Maggiore – Centre', type: 'technical' },
  { id: 35, name: 'Autodrome Lago Maggiore – Centre Reverse', type: 'technical' },
  { id: 36, name: 'Autodrome Lago Maggiore – East', type: 'technical' },
  { id: 37, name: 'Autodrome Lago Maggiore – East End', type: 'technical' },
  { id: 38, name: 'Autodrome Lago Maggiore – Full Course', type: 'technical' },
  { id: 39, name: 'Autodrome Lago Maggiore – Full Reverse', type: 'technical' },
  { id: 40, name: 'Autodrome Lago Maggiore – West', type: 'technical' },
  { id: 41, name: 'Autodrome Lago Maggiore – West End', type: 'technical' },
  { id: 42, name: 'Autódromo de Interlagos', type: 'technical' },
  { id: 43, name: 'Autopolis International Racing Course', type: 'technical' },
  { id: 44, name: 'BB Raceway', type: 'technical' },
  { id: 45, name: 'BB Raceway Reverse', type: 'technical' },
  { id: 46, name: 'Blue Moon Bay Infield A', type: 'technical' },
  { id: 47, name: 'Blue Moon Bay Infield A Reverse', type: 'technical' },
  { id: 48, name: 'Blue Moon Bay Infield B', type: 'technical' },
  { id: 49, name: 'Blue Moon Bay Infield B Reverse', type: 'technical' },
  { id: 50, name: 'Brands Hatch Grand Prix Circuit', type: 'technical' },
  { id: 51, name: 'Brands Hatch Indy Circuit', type: 'technical' },
  { id: 52, name: 'Circuit de Barcelona-Catalunya GP Layout', type: 'technical' },
  { id: 53, name: 'Circuit de Barcelona-Catalunya GP Layout No Chicane', type: 'technical' },
  { id: 54, name: 'Circuit de Barcelona-Catalunya National Layout', type: 'technical' },
  { id: 55, name: 'Circuit de Barcelona-Catalunya Rallycross Layout', type: 'technical' },
  { id: 56, name: 'Circuit de Spa-Francorchamps', type: 'technical' },
  { id: 57, name: 'Colorado Springs – Lake', type: 'technical' },
  { id: 58, name: 'Colorado Springs – Lake Reverse', type: 'technical' },
  { id: 59, name: 'Daytona Road Course', type: 'technical' },
  { id: 60, name: 'Deep Forest Raceway', type: 'technical' },
  { id: 61, name: 'Deep Forest Raceway Reverse', type: 'technical' },
  { id: 62, name: 'Dragon Trail – Gardens', type: 'technical' },
  { id: 63, name: 'Dragon Trail – Gardens Reverse', type: 'technical' },
  { id: 64, name: 'Dragon Trail – Seaside', type: 'technical' },
  { id: 65, name: 'Dragon Trail – Seaside Reverse', type: 'technical' },
  { id: 66, name: 'Eiger Nordwand', type: 'technical' },
  { id: 67, name: 'Eiger Nordwand Reverse', type: 'technical' },
  { id: 68, name: 'Fishermans Ranch', type: 'technical' },
  { id: 69, name: 'Fishermans Ranch Reverse', type: 'technical' },
  { id: 70, name: 'Goodwood Motor Circuit', type: 'technical' },
  { id: 71, name: 'Grand Valley – South', type: 'technical' },
  { id: 72, name: 'Grand Valley – South Reverse', type: 'technical' },
  { id: 73, name: 'Kyoto Driving Park – Miyabi', type: 'technical' },
  { id: 74, name: 'Kyoto Driving Park – Yamagiwa', type: 'technical' },
  { id: 75, name: 'Kyoto Driving Park – Yamagiwa Reverse', type: 'technical' },
  { id: 76, name: 'Kyoto Driving Park – Yamagiwa+Miyabi', type: 'technical' },
  { id: 77, name: 'Kyoto Driving Park – Yamagiwa+Miyabi Reverse', type: 'technical' },
  { id: 78, name: 'Lake Louise Long', type: 'technical' },
  { id: 79, name: 'Lake Louise Short', type: 'technical' },
  { id: 80, name: 'Lake Louise Tri-Oval', type: 'technical' },
  { id: 81, name: 'Michelin Raceway Road Atlanta', type: 'technical' },
  { id: 82, name: 'Mount Panorama Motor Racing Circuit', type: 'technical' },
  { id: 83, name: 'Nurburgring 24h', type: 'technical' },
  { id: 84, name: 'Nurburgring GP', type: 'technical' },
  { id: 85, name: 'Nurburgring Nordschleife', type: 'technical' },
  { id: 86, name: 'Nurburgring Nordschleife Tourist', type: 'technical' },
  { id: 87, name: 'Nurburgring Sprint', type: 'technical' },
  { id: 88, name: 'Sardegna – Road Track – A Reverse', type: 'technical' },
  { id: 89, name: 'Sardegna – Road Track – B', type: 'technical' },
  { id: 90, name: 'Sardegna – Road Track – B Reverse', type: 'technical' },
  { id: 91, name: 'Sardegna – Road Track – C', type: 'technical' },
  { id: 92, name: 'Sardegna – Road Track – C Reverse', type: 'technical' },
  { id: 93, name: 'Sardegna – Windmills', type: 'technical' },
  { id: 94, name: 'Sardegna – Windmills Reverse', type: 'technical' },
  { id: 95, name: 'Suzuka Circuit', type: 'technical' },
  { id: 96, name: 'Suzuka Circuit East Course', type: 'technical' },
  { id: 97, name: 'Tokyo Expressway – Central', type: 'technical' },
  { id: 98, name: 'Tokyo Expressway – Central Reverse', type: 'technical' },
  { id: 99, name: 'Tokyo Expressway – East', type: 'technical' },
  { id: 100, name: 'Tokyo Expressway – East Reverse', type: 'technical' },
  { id: 101, name: 'Tokyo Expressway – South', type: 'technical' },
  { id: 102, name: 'Tokyo Expressway – South Reverse', type: 'technical' },
  { id: 103, name: 'Trial Mountain Circuit', type: 'technical' },
  { id: 104, name: 'Trial Mountain Circuit Reverse', type: 'technical' },
  { id: 105, name: 'Tsukuba Circuit', type: 'technical' },
  { id: 106, name: 'Willow Springs – Big Willow', type: 'technical' },
  { id: 107, name: 'Willow Springs – Horse Thief Mile', type: 'technical' },
  { id: 108, name: 'Willow Springs – Horse Thief Mile Reverse', type: 'technical' },
  { id: 109, name: 'Willow Springs – Streets of Willow', type: 'technical' },
  { id: 110, name: 'Willow Springs – Streets of Willow Reverse', type: 'technical' },
  { id: 111, name: 'Yas Marina Circuit - Full Course', type: 'technical' },
  { id: 112, name: 'Circuit Gilles Villeneuve - Full Course', type: 'technical' }
]
